import { defineComponent, computed, inject, watchEffect } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import { generateElementId } from '../../helpers/generators.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WatchlistSelector",
  props: {
    locale: { type: null, required: true },
    value: { type: null, required: true },
    autoSelectOnMultiple: { type: Boolean, required: false, default: true }
  },
  emits: ["store-error", "data-load", "input"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const componentInputs = computed(() => ({
      value: props.value
    }));
    const selectorId = generateElementId("fds-watchlist-selector-");
    const hasError = computed(() => {
      return !isLoadingStoreData.value && props.value === null;
    });
    const watchlistList = computed(() => {
      var _a;
      return (_a = storeData.value) != null ? _a : [];
    });
    const onWatchlistChange = ($event) => {
      emits("input", $event.target.value);
    };
    const setWatchlistIfNull = () => {
      const canAutoSelect = props.autoSelectOnMultiple || watchlistList.value.length === 1;
      if (watchlistList.value.length > 0 && !props.value && canAutoSelect) {
        emits("input", watchlistList.value[0].id);
      }
    };
    const getWatchlistKey = (watchlist) => {
      return JSON.stringify(watchlist.id);
    };
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate } = localizationSupport;
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { storeData, isLoadingStoreData } = storeModule;
    watchEffect(setWatchlistIfNull);
    return { __sfc: true, props, emits, componentInputs, selectorId, hasError, watchlistList, onWatchlistChange, setWatchlistIfNull, getWatchlistKey, localizationSupport, translate, storeModule, storeData, isLoadingStoreData };
  }
});

export { _sfc_main as default };
